import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";
import { getQuery } from "../_helpers/query.helper";

const API_NAME = "chat";

export const chatService = {
    getChatHistory,
    getGroupChatHistory
};

function getChatHistory(user1: string, user2: string, isRead?: any, query?: any,) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetChatHistory/?user1=${user1}&user2=${user2}&isRead=${isRead}&${getQuery(query)}`, requestOptions)
        .then(handleResponse);
}

function getGroupChatHistory(groupId: number, groupMemebrUserId?: any, isRead?: any, query?: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetGroupChatHistory/?groupId=${groupId}&groupMemebrUserId=${groupMemebrUserId}&isRead=${isRead}&${getQuery(query)}`, requestOptions)
        .then(handleResponse);
}